import { useEventHandler } from '../../../../../hooks/useEventHandler';
import { useFileDownload } from '../../../../../hooks/useFileDownloader';
import { createParams } from '../../../../../utils/queries';
import { USER_BASE_PATH } from '../../constants/userBasePath';
import { UserSearchParams } from '../../types/UserSearchParams';

export const useDownloadUsers = () => {
  const { download: fileDownload, isPending } = useFileDownload();

  const download = useEventHandler(
    (queryParams: UserSearchParams, filename: string) => {
      fileDownload(
        `${USER_BASE_PATH}/export/csv`,
        filename,
        createParams(queryParams as Record<string, any>),
      );
    },
  );

  return { download, isPending };
};
